import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { appActions } from '../app/app.actions';
import { privacyCenterActions } from '../../src/details/privacyCenter/privacyCenter.actions';
import Footer from './Footer';

function mapStateToProps(state) {
    return {
        loggedIn: state.app.memberLoggedIn,
        localeSet: state.app.locale,
        UserRealName: state.member ? `${state.member.firstName} ${state.member.lastName}` : '',
        clientConfig: state.app.clientConfig,
        appConfig: state.app.appConfig,
        disabledAgreementReq: state.app.clientConfig.disabledAgreementReq,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setAndSaveLocale: (prevLocale, nextLocale) =>
            dispatch(appActions.setAndSaveLocale(prevLocale, nextLocale)),
        changeCmpLanguage: (lang) =>
            dispatch(privacyCenterActions.loadServicesAndConsentsStatus(lang)),
    };
}

const FooterContainer = injectIntl(connect(mapStateToProps, mapDispatchToProps)(Footer));

export default FooterContainer;
